import { TLearningProgressIndustryOutputDto } from "@/api/services/main/learning-progress/dtos/get-learning-progress-list.dto";
import { IndustryNameLabel } from "@/components/elements/IndustryNameLabel";
import { InnerBox } from "@/components/elements/InnerBox";
import { AppRoutes } from "@/routes/config";
import { button, text } from "@/theme/colors";
import { spacing } from "@/theme/variables";
import { getDynamicRoute } from "@/utils/url";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

type TLearningProgressItemProps = {
  industryNames: string[];
  industry: TLearningProgressIndustryOutputDto;
};

export const LearningProgressItem: FC<TLearningProgressItemProps> = ({ industry, industryNames }) => {
  const navigate = useNavigate();
  const hasUsers = industry.learnerCount > 0;

  const handleClick = () => {
    navigate(getDynamicRoute(AppRoutes.learningProgressDetail, { industryId: industry.id }));
  };

  return (
    <InnerBox
      padding="0"
      showDivider={false}
      sx={{
        cursor: "pointer",
        overflow: "hidden",
      }}
      onClick={handleClick}
    >
      <Stack direction="row" alignItems="center">
        <IndustryNameLabel name={industry.name} allNames={industryNames} />
        <Stack direction="row" alignItems="center" justifyContent="space-between" p={spacing.sm} flex={1}>
          <Stack direction="row" gap={spacing.xs} alignItems="center" flex={1}>
            {hasUsers ? (
              <Typography component="p" variant="body14" color={text.secondary}>
                有効アカウント数:{" "}
                <Typography variant="body14Semi" color={text.primary}>
                  {industry.learnerCount}名
                </Typography>
              </Typography>
            ) : (
              <Typography component="p" variant="body14" color={text.secondary}>
                現在有効アカウント数の登録なし
              </Typography>
            )}
            {hasUsers && industry.notLogin7DaysCount > 0 && (
              <>
                <Stack sx={{ width: "1px", height: "14px", bgcolor: text.disable }} />
                <Typography component="p" variant="body14" color={button.danger}>
                  未ログイン(7日間): <Typography variant="body14Semi">{industry.notLogin7DaysCount}名</Typography>
                </Typography>
              </>
            )}
          </Stack>
          <ChevronRightIcon sx={{ color: text.secondary }} />
        </Stack>
      </Stack>
    </InnerBox>
  );
};
